module.exports = __webpack_public_path__ + "img/p3.47d64fdb.png";